import useSWR from 'swr'
import {
  listProduct,
  listProductUrl,
  listProductPriceUrl,
  listProductPrice,
  listProductPriceDiffUrl,
  listProductPriceDiff,
} from '@/apis/subscribe'
import { GoodsType } from '@/types/subscribe'
import { userState } from '@/store/user'
import { useRecoilValue } from 'recoil'
import { useMemo } from 'react'

export default function useGemsProductInfo() {
  const user = useRecoilValue(userState)
  const { data: allProductMap } = useSWR(
    user?.user_id ? listProductUrl : () => undefined,
    listProduct
  )
  const goodsInfo = useMemo(
    () => [
      ...(allProductMap?.[GoodsType.Gems] ?? []),
      ...(allProductMap?.[GoodsType.Activity] ?? []),
    ],
    [allProductMap]
  )
  const productOriginIds = useMemo(
    () => goodsInfo.map((o) => o.product_origin_id),
    [goodsInfo]
  )
  const gemProductOriginIds = useMemo(
    () =>
      (allProductMap?.[GoodsType.Gems] ?? []).map((o) => o.product_origin_id),
    [allProductMap]
  )
  const { data: allGemsProductRes, isLoading: allGemsProductLoading } = useSWR(
    productOriginIds.length > 0 && {
      endpoint: listProductPriceUrl,
      productIds: productOriginIds,
    },
    listProductPrice
  )
  const { data: allGemsProductPriceDiffRes } = useSWR(
    gemProductOriginIds.length > 0 && {
      endpoint: listProductPriceDiffUrl,
      productIds: gemProductOriginIds,
    },
    listProductPriceDiff
  )
  return {
    goodsInfo,
    allProductMap,
    allGemsProductRes,
    allGemsProductPriceDiffRes,
    goodsAmountMapLoading: allGemsProductLoading,
  }
}
